import React from 'react'
import './Ourproduct.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Mousewheel } from "swiper";
import "swiper/css";
import { useState } from "react";
import projects from '../../utils/projects.json';

const Ourproduct = () => {
    const [imagesNavSlider, setImagesNavSlider] = useState(null);
    const [mainSwiper, setMainSwiper] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    return (

        <section className="ourproduct-section">
        <div className="App">

            <p className="sgrid-eyebrow">PORTFOLIO</p>
            <h2 className="ourproduct-title">Our Impressive Projects</h2>
            <p className="ourproduct-subtitle">Digital products shipped across hospitality, ecommerce and growth-focused brands.</p>
        <section className="slider">
          <div className="mobile-project-nav">
            {projects.map((project, index) => (
              <button
                key={`${project.name}-tab`}
                type="button"
                className={activeIndex === index ? 'is-active' : ''}
                onClick={() => {
                  if (mainSwiper) {
                    mainSwiper.slideTo(index)
                  }
                }}
              >
                {project.name}
              </button>
            ))}
          </div>
          <div className="slider__flex">
            <div className="slider__col">
              <div className="slider__prev">Prev</div>
  
              <div className="slider__thumbs">
                <Swiper
                  onSwiper={setImagesNavSlider}
                  direction="vertical"
                  spaceBetween={15}
                  slidesPerView={8}
                  navigation={{
                    nextEl: ".slider__next",
                    prevEl: ".slider__prev"
                  }}
                  className="swiper-container1"
                  breakpoints={{
                    0: {
                      direction: "horizontal"
                    },
                    768: {
                      direction: "vertical"
                    }
                  }}
                  modules={[Navigation, Thumbs]}
                >
                    {projects.map((project) => (
                      <SwiperSlide key={project.name}>
                        <div className="slider__image">
                          <h4>{project.name}</h4>
                          <p>{project.client}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
  
              <div className="slider__next">Next</div>
            </div>
  
            <div className="slider__images">
              <Swiper
                onSwiper={setMainSwiper}
                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                thumbs={{ swiper: imagesNavSlider }}
                direction="horizontal"
                slidesPerView={1}
                spaceBetween={32}
                mousewheel= {{
                    releaseOnEdges: true,
                }}
                navigation={{
                  nextEl: ".slider__next",
                  prevEl: ".slider__prev"
                }}
                breakpoints={{
                  0: {
                    direction: "horizontal"
                  },
                  768: {
                    direction: "horizontal"
                  }
                }}
                className="swiper-container2"
                modules={[Navigation, Thumbs, Mousewheel]}
              >
                {projects.map((project) => (
                  <SwiperSlide key={`${project.name}-preview`}>
                    <div className="slider__image">
                      <img src={project.image} alt={`${project.name} website preview`} />
                    </div>
                    <div className="slide-content-wrap">
                      <h4>{project.name}</h4>
                      <p>{project.description}</p>
                    </div>
                    <div className='slider-cta-container'>
                      <a className='ourproduct-visit-btn' href={project.url}>Visit Website</a>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>
      </div>
      </section>
    );
}

export default Ourproduct
